import { IMedia } from '@/types/interfaces';
import { PHOTO_SIZES, PHOTO_VIEW_TYPE } from '@/types/enums';

export function lowResUrlByMedia(photo: IMedia, width = PHOTO_SIZES.MD):string {
  return `${process.env.VUE_APP_MEDIA_URL}${photo?.fileUrl}/${width}`;
}

export function lowResUrlByUrl(url: string, width = PHOTO_SIZES.MD):string {
  return `${process.env.VUE_APP_MEDIA_URL}${url}/${width}`;
}

export function lowResUrlByViewType(photo: IMedia, viewType = PHOTO_VIEW_TYPE.WIDTH):string {
  if (viewType === PHOTO_VIEW_TYPE.THUMB) {
    return process.env.VUE_APP_MEDIA_URL + photo?.previewUrl;
  }
  return `${process.env.VUE_APP_MEDIA_URL}${photo?.fileUrl}/${viewType}`;
}

export function lowResUrlByViewTypeByUrl(url: string, viewType = PHOTO_VIEW_TYPE.WIDTH):string {
  if (viewType === PHOTO_VIEW_TYPE.THUMB) {
    return `${process.env.VUE_APP_MEDIA_URL}${url}`;
  }
  return `${process.env.VUE_APP_MEDIA_URL}${url}/${viewType}`;
}
